import { Box } from 'shared/mui/Box';
import { Typography } from 'shared/mui/Typography';

type Props = {
  convertedValue: string;
  convertedCurrency: string | null | undefined;
  originalValue?: string | false;
  originalCurrency?: string;
  color: string;
};

export const BalanceReportDatagridAmountDataField: React.FC<Props> = ({
  convertedValue,
  convertedCurrency,
  originalValue,
  originalCurrency,
  color,
}) => {
  if (!convertedCurrency) {
    return <></>;
  }

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'end', textAlign: 'end' }}>
      <Typography color={color} fontWeight={originalValue ? 400 : 500} noWrap variant="body2">
        {convertedValue}{' '}
        <Typography component="span" fontWeight={originalValue ? 400 : 500} variant="body2">
          {convertedCurrency}
        </Typography>
      </Typography>
      {originalValue && originalCurrency && (
        <Typography color="#00000061" noWrap variant="body2">
          {originalValue}{' '}
          <Typography component="span" variant="body2">
            {originalCurrency}
          </Typography>
        </Typography>
      )}
    </Box>
  );
};
